import { Component } from '@angular/core';

import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'app-pause-icon',
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.99935 0.666748C3.94926 0.666748 0.666016 3.94999 0.666016 8.00008C0.666016 12.0502 3.94926 15.3334 7.99935 15.3334C12.0494 15.3334 15.3327 12.0502 15.3327 8.00008C15.3327 3.94999 12.0494 0.666748 7.99935 0.666748ZM6.99935 6.00008C6.99935 5.63189 6.70087 5.33342 6.33268 5.33342C5.96449 5.33342 5.66602 5.63189 5.66602 6.00008V10.0001C5.66602 10.3683 5.96449 10.6667 6.33268 10.6667C6.70087 10.6667 6.99935 10.3683 6.99935 10.0001V6.00008ZM10.3327 6.00008C10.3327 5.63189 10.0342 5.33342 9.66602 5.33342C9.29783 5.33342 8.99935 5.63189 8.99935 6.00008V10.0001C8.99935 10.3683 9.29783 10.6667 9.66602 10.6667C10.0342 10.6667 10.3327 10.3683 10.3327 10.0001V6.00008Z"
        [attr.fill]="color"
      />
    </svg>
  `,
})
export class PauseIcon extends BaseIconComponent {}
